
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zmien-haslo",
      function () {
        return require("private-next-pages/zmien-haslo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zmien-haslo"])
      });
    }
  